export enum FormRegisterTypeEnum {
  Register = 'registerForm',
}
